export function createLogsDataLoadedHandler($scope, chartModel) {
    return () => {
        if (chartModel?.sf_id) {
            $scope.$root.$broadcast('logs-chart-data-loaded', chartModel.sf_id);
            $scope.$applyAsync();
        }
    };
}

// Infra navigator (/navigator/:orgID/:modeID) and old olly entity detail (/infra/entity/:entityId)
// share the same entity ID vocabulary, so one map covers both.
const INFRA_ENTITY_TO_OOTB_SOURCE = {
    k8snodes: 'OOTB-Logs-Chart-K8snodes',
    k8spods: 'OOTB-Logs-Chart-K8spods',
    k8scontainers: 'OOTB-Logs-Chart-K8scontainers',
    k8sworkloads: 'OOTB-Logs-Chart-K8sworkloads',
};

// New Kubernetes experience (/kubernetes-entities?entityView=<type>) entity view values
const K8S_ENTITY_VIEW_TO_OOTB_SOURCE = {
    nodes: 'OOTB-Logs-Chart-K8snodes',
    pods: 'OOTB-Logs-Chart-K8spods',
    containers: 'OOTB-Logs-Chart-K8scontainers',
    deployments: 'OOTB-Logs-Chart-K8sworkloads',
    daemonsets: 'OOTB-Logs-Chart-K8sworkloads',
    statefulsets: 'OOTB-Logs-Chart-K8sworkloads',
    replicasets: 'OOTB-Logs-Chart-K8sworkloads',
    cronjobs: 'OOTB-Logs-Chart-K8sworkloads',
    jobs: 'OOTB-Logs-Chart-K8sworkloads',
};

// Standalone K8s navigator (/k8s/:selectedTab) tab keys → OOTB-Logs-Chart-* sources
// Keys must match the actual tab IDs defined in kubeNavigator.js
const K8S_SELECTED_TAB_TO_OOTB_SOURCE = {
    nodeList: 'OOTB-Logs-Chart-K8snodes',
    nodeDetail: 'OOTB-Logs-Chart-K8snodes',
    workloadsList: 'OOTB-Logs-Chart-K8sworkloads',
    workloadDetail: 'OOTB-Logs-Chart-K8sworkloads',
    podDetail: 'OOTB-Logs-Chart-K8spods',
    containerDetail: 'OOTB-Logs-Chart-K8scontainers',
};

const OLLY_ENTITY_PATH_PREFIX = '/infra/entity/';
const KUBERNETES_ENTITIES_PATH = '/kubernetes-entities';

// e.g. '/infra/entity/k8snodes' → 'k8snodes', anything else → null
export function extractEntityModeIdFromPathname(pathname) {
    if (!pathname?.startsWith(OLLY_ENTITY_PATH_PREFIX)) return null;
    return pathname.slice(OLLY_ENTITY_PATH_PREFIX.length).split('/')[0] || null;
}

export function extractOotbSourceFromKubernetesEntitiesPath(pathname, entityView) {
    if (pathname !== KUBERNETES_ENTITIES_PATH) return null;
    return K8S_ENTITY_VIEW_TO_OOTB_SOURCE[entityView] ?? 'OOTB-Logs-Chart-Nav';
}

export function resolveOotbSearchJobSource(
    isBuiltInChart,
    navigatorModeID,
    selectedTab,
    kubernetesEntitiesSource
) {
    if (!isBuiltInChart) {
        return undefined;
    }
    if (kubernetesEntitiesSource) {
        return kubernetesEntitiesSource;
    }
    if (navigatorModeID) {
        return INFRA_ENTITY_TO_OOTB_SOURCE[navigatorModeID] ?? 'OOTB-Logs-Chart-Nav';
    }
    if (selectedTab) {
        return K8S_SELECTED_TAB_TO_OOTB_SOURCE[selectedTab] ?? 'OOTB-Logs-Chart-Nav';
    }
    return 'OOTB-Logs-Chart';
}
